import type { SkillDef, PipelineNode, PipelineEdge } from '@/mocks/pipeline';
import { NODE_W } from './flowUtils';
import { PROMPT_Y, skillStartX } from './promptNode';

export type ComposeRecommendation = { id: string; name: string; why: string };

const X_START = skillStartX();
const Y = PROMPT_Y;
const X_STEP = NODE_W + 80;

export function pickEdgeField(from: SkillDef, to: SkillDef): string {
  for (const out of from.outputs) {
    if (to.inputs.some((i) => i.name === out.name)) return out.name;
  }
  for (const out of from.outputs) {
    const match = to.inputs.find((i) => i.type === out.type);
    if (match) return out.name;
  }
  return from.outputs[0]?.name ?? to.inputs[0]?.name ?? 'text';
}

export function buildComposePipeline(
  recommendations: ComposeRecommendation[],
  skillMap: Record<string, SkillDef>,
  now = Date.now(),
): { nodes: PipelineNode[]; edges: PipelineEdge[] } {
  const nodes: PipelineNode[] = [];
  const edges: PipelineEdge[] = [];

  recommendations.forEach((rec, i) => {
    const skill = skillMap[rec.id];
    if (!skill) return;

    const id = `n${now}-${i}`;
    nodes.push({
      id,
      skillId: rec.id,
      x: X_START + i * X_STEP,
      y: Y,
      status: 'idle',
      note: rec.why,
      body: skill.body ?? '',
    });

    if (i === 0) return;
    const prev = nodes[i - 1];
    const fromSkill = skillMap[prev.skillId];
    const toSkill = skill;
    if (!fromSkill) return;
    edges.push({
      id: `e${now}-${i}`,
      from: prev.id,
      to: id,
      field: pickEdgeField(fromSkill, toSkill),
    });
  });

  return { nodes, edges };
}
